<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" />
      <el-button type="primary" :class="isChinese === 'zh-cn' ? 'btn1' : 'btn3'" @click="dialogFormVisible = true">{{
        $t("page.productInfo.btn.add") }}</el-button>
      <!-- 添加产品 -->
      <!--   批量删除按钮   -->
      <el-button type="primary" class="btn2" @click="batchRemove">{{
        $t("page.productInfo.btn.del")
      }}</el-button>
      <!-- 删除 -->
      <el-table ref="multipleTable" :data="tableData1" border style="width: 1140px" @selection-change="selectionChange"
        class="multifunctional-table dic-sub-table-style01">
        <!-- tableData1.slice((pageNum-1)*pageSize,pageNum*pageSize)  -->
        <el-table-column type="selection" width="30" />
        <el-table-column :label="$t('page.productInfo.tableTh.productCode')" width="100" prop="matcateryCode">
          <!-- 产品编码 -->
        </el-table-column>
        <el-table-column :label="$t('page.productInfo.tableTh.productName')" width="250" prop="matcateryName">
          <!-- 产品名称 -->
        </el-table-column>
        <el-table-column :label="$t('page.productInfo.tableTh.productTrademark')" width="150" prop="matTrademark">
          <!-- 产品商标 -->
          <template v-slot="{ row }">
            <el-input class="big" v-model="row.matTrademark" :placeholder="$t('page.productInfo.dialog.inp')"
              maxlength="150"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('page.productInfo.tableTh.remark')" width="150" prop="prodinfoRemark">
          <!-- 备注 -->
          <template v-slot="{ row }">
            <el-input class="big" v-model="row.prodinfoRemark" :placeholder="$t('page.productInfo.dialog.inp')"
              maxlength="1500"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('page.productInfo.tableTh.operation')" width="70">
          <!-- 操作 -->
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="approval-btn" @click="handleRemove(scope.row)">{{
              $t("page.productInfo.btn.del") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页条  -->
      <!--      <el-pagination-->
      <!--        @size-change="handleSizeChange"-->
      <!--        @current-change="handleCurrentChange"-->
      <!--        :current-page="pageNum"-->
      <!--        :page-sizes="[10, 20, 30, 40]"-->
      <!--        :page-size="pageSize"-->
      <!--        layout="total, sizes, prev, pager, next, jumper"-->
      <!--        :total="tableData1.length"-->
      <!--        background-->
      <!--      >-->
      <!--      </el-pagination>-->
    </div>
    <div class="btnBox">
      <el-button class="left-btn btn" size="mini" type="primary-icon-medium" @click="back()">
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button class="right-btn btn" size="mini" type="primary-icon-medium" @click="next()">
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
    <!--添加产品树弹框-->
    <chooseTree :dialogFormVisible.sync="dialogFormVisible" :default-data="defaultData" @handleTrue="handleTrue">
    </chooseTree>
  </div>
</template>

<script>

/* eslint-disable */
import chooseTree from './chooseTree'
import { qryMatcateryTreeList, saveSupplierRegistInfo, qrySupRegistProductInfo } from '../../../api/supRegister'
import Setting from "@/setting/setting";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;
import { mapActions } from "vuex";
export default {
  name: "productInformation",
  components: { chooseTree },
  data() {
    return {

      title: window.$t('page.productInfo.contentTitle.productInfo'),     // 产品信息
      tableData1: [],
      dialogFormVisible: false,
      conditionCheckbox: true,
      tableData: [],
      rightTableData: [],
      treeProps: {
        label: "categoryName",
        children: "childNodes",
        isLeaf: "isLeaf"
      },
      gridData: [],
      dialogTableVisibletextarea: false,
      formData: {
        matName: "",
        matNum: "",
        pageNo: 1,
        pageSize: 10,
        catalogId: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      present: "",
      total: 0,
      lastTime: {
        button: false
      },
      materialsData: [], // 物资选择数据
      isTurnPage: false, // 是否有翻页
      treeArray: [],
      supInfoApplyId: '',
      pageNum: 1,
      pageSize: 10,
      selectArr: [],
      isChinese: Cookies.get(savedLocaleKey) || 'zh-cn'
    }
  },
  created() {
    if (this.$route.query.page) {
      this.changeCheckPage(6)
    }
    if (Cookies.get('access_token') || this.$route.query.tempSupinfoId) {
      this.getSupRegistProductInfo()
    }
    if (this.$route.path == '/maPerfectInfo/productInformation') {
      this.changeCheckPage(6);
      for (let i = 0; i < 3; i++) {
        this.msgCenter.$emit('ballMoveRight')
      }
    }
  },
  computed: {
    defaultData() {
      return this.tableData1.map(item => item.matcateryCode)
    }
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    //添加产品弹框点击确定
    handleTrue(data) {
      data = data.map(  item => {
    let z =   this.tableData1.find(i => i.matcateryCode == item.id)
        return {
          parentMatcateryCode: item.parentMatcateryCode,
          matcateryTreePath: item.matcateryTreePath,
          matcateryCode: item.id,
          matcateryName: item.name,
          matTrademark: z ? z.matTrademark : "",
          prodinfoRemark: z ? z.prodinfoRemark : "",
        }
      })
      // //子节点全选不展示子节点，只展示父节点
      // for (let j = data.length - 1; j >= 0; j--) {
      //   let item = data[j]
      //   for (let i = this.tableData1.length - 1; i >= 0; i--) {
      //     //去重
      //     if (this.tableData1[i].matcateryCode === item.matcateryCode) {
      //       console.log("step01");
      //       this.$delete(this.tableData1, i);
      //       continue;
      //     }
      //     //新增的有子节点，则删除原来有的父节点
      //     if (item.matcateryTreePath.indexOf("-" + this.tableData1[i].matcateryCode + "-") !== -1) {
      //       console.log("step02");
      //       this.$delete(data, j);
      //       continue;
      //     }
      //     //新增的有父节点，则删除原来有的子节点
      //     if (this.tableData1[i].matcateryTreePath.indexOf("-" + item.matcateryCode + "-") !== -1) {
      //       console.log("step03");
      //       this.$delete(this.tableData1, i);
      //       continue;
      //     }
      //   }
      // }
    
      this.$nextTick(() =>{
        this.tableData1 = [...data];
      });
      // this.tableData1 = [...[], ...this.tableData1, ...data];
    },
    back() {
      this.changeCheckPage(5)
      this.$router.push({ path: '/maPerfectInfo/contactInformation', query: { tempSupinfoId: this.$route.query.tempSupinfoId } })
    },
    next() {
      if (this.isChinese === 'zh-cn') {
        if (this.tableData1.length === 0) {
          this.$message.error(window.$t('page.productInfo.dialog.nextMsg'))
        } else {
          let params = {
            dataSourceFlag: 0,
            isOverseas: window.languagezh_cn ? 0 : 1,
            supRegistProductInfoList: this.tableData1,
            isShowLoading: true,
            tempSupinfoId: this.supInfoApplyId,
            // supRegistAccountInfoBO:{
            //   countyCode:sessionStorage.getItem('countyCode'),
            //   countyName:sessionStorage.getItem('countyName'),
            // },
            supRegistTab: 7
          };
          saveSupplierRegistInfo(params).then(res => {
            if (res.data.code === "0") {
              this.changeCheckPage(8)
              // this.$router.push({path:'/maPerfectInfo/financialInformation',query: {tempSupinfoId: this.$route.query.tempSupinfoId}})
              this.$router.push({ path: '/maPerfectInfo/qualificationDocuments', query: { tempSupinfoId: this.$route.query.tempSupinfoId } })
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      } else {
        let params = {
          dataSourceFlag: 0,
          isOverseas: window.languagezh_cn ? 0 : 1,
          supRegistProductInfoList: this.tableData1,
          tempSupinfoId: this.supInfoApplyId,
          supRegistTab: 7
        };
        saveSupplierRegistInfo(params).then(res => {
          if (res.data.code === "0") {
            this.changeCheckPage(8)
            // this.$router.push({path:'/maPerfectInfo/financialInformation',query: {tempSupinfoId: this.$route.query.tempSupinfoId}})
            this.$router.push({ path: '/maPerfectInfo/qualificationDocuments', query: { tempSupinfoId: this.$route.query.tempSupinfoId } })
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    handleRemove(row) {
      this.$confirm(`${window.$t('page.productInfo.delInfo.delInfo')}`, `${window.$t('page.productInfo.dialog.info')}`, {
        confirmButtonText: window.$t('page.productInfo.btn.confirm'),
        cancelButtonText: window.$t('page.productInfo.btn.cancel'),
        type: 'warning',
      }).then(() => {
        this.tableData1 = this.tableData1.filter(item => {
          return item.matcateryCode != row.matcateryCode
        })
        if (this.tableData1.length >= this.pageSize && this.tableData1.length % this.pageSize === 0 && this.pageNum !== 1) {
          this.pageNum = this.pageNum - 1
        } else {
          this.pageNum = this.pageNum
        }
        this.$message({
          type: 'success',
          message: window.$t('page.productInfo.delInfo.confirmDel')  // 删除成功
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: window.$t('page.productInfo.delInfo.cancelInfo')  // 已取消删除
        });
      });
    },
    // 获取产品信息
    async getSupRegistProductInfo() {
      const { data } = await qrySupRegistProductInfo({
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag ? this.$route.query.tempOrFormalFlag : 0,
        supInfoApplyId: this.$route.query.tempSupinfoId,
        isShowLoading: true,
      })
      console.log(data)
      if (data.code === '0') {
        this.tableData1 = data.data.supRegistProductInfoList
        this.supInfoApplyId = data.data.supInfoApplyId
      }
    },
    // 查询设备物资类别树列表
    async getMatcateryTreeList() {
      try {
        const { data } = await qryMatcateryTreeList({
          parentMatcateryCode: '01'
        })
        console.log(data)
      } catch (err) {
        console.log(err)
      }
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
    },
    handleCurrentChange(newNum) {
      this.pageNum = newNum
    },
    selectionChange(selection) {
      this.selectArr = []
      selection.forEach(item => {
        this.selectArr.push(item.matcateryCode)
      })
    },
    // 批量删除
    batchRemove() {
      if (this.selectArr.length === 0) {
        this.$message.error($t('page.productInfo.delInfo.batchDelInfo'))
      } else {
        this.$confirm(`${window.$t('page.productInfo.delInfo.delInfo')}`, `${window.$t('page.productInfo.dialog.info')}`, {
          confirmButtonText: window.$t('page.productInfo.btn.confirm'),
          cancelButtonText: window.$t('page.productInfo.btn.cancel'),
          type: 'warning',
        }).then(() => {
          this.selectArr.forEach(item => {
            this.tableData1.forEach((item2, index) => {
              if (item === item2.matcateryCode) {
                this.tableData1.splice(index, 1)
              }
            })
            if (this.tableData1.length >= this.pageSize && this.tableData1.length % this.pageSize === 0 && this.pageNum !== 1) {
              this.pageNum = this.pageNum - 1
            } else {
              this.pageNum = this.pageNum
            }
          })
          this.$message({
            type: 'success',
            message: window.$t('page.productInfo.delInfo.confirmDel')  // 删除成功
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: window.$t('page.productInfo.delInfo.cancelInfo')  // 已取消删除
          });
        });
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../css/index.scss";

.sign-content {
  position: relative;
  width: 1180px;
  background: #FFFFFF;
  margin: 20px auto;
  overflow: hidden;

  .el-card-title {
    margin: 20px;

    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
    }
  }

  /deep/ .btn1 {
    background: #FF142F;
    border-color: #ff142f;
    position: absolute;
    right: 76px;
    font-family: PingFangSC-Medium;
    font-size: 13px;
    letter-spacing: 0;
    font-weight: 500;
  }

  /deep/ .btn1:hover,
  .btn1:hover {
    border-color: #ff142f;
    background: rgba(255, 20, 47, 1);
  }

  /deep/ .btn3 {
    background: #FF142F;
    border-color: #ff142f;
    position: absolute;
    right: 86px;
    font-family: PingFangSC-Medium;
    font-size: 13px;
    letter-spacing: 0;
    font-weight: 500;
  }

  /deep/ .btn3:hover,
  .btn3:hover {
    border-color: #ff142f;
    background: rgba(255, 20, 47, 1);
  }

  /deep/ .el-button.el-button--add-button .icon-ccui-add {
    color: #FF142F;
    margin-right: 10px;
  }

  /deep/ .el-button.el-button--add-button span {
    color: #FF142F;
  }

  /deep/ .btn2 {
    position: absolute;
    right: 20px;
    background: #FF142F;
    border-color: #ff142f;
  }

  /deep/ .btn2:hover,
  .btn2:hover {
    border-color: #ff142f;
    background: rgba(255, 20, 47, 1);
  }

  /deep/ .el-table {
    margin: 70px auto;

    .small .el-input__inner {
      width: 190px;
      border-radius: 0px;
    }

    .big .el-input__inner {
      width: 200px;
      border-radius: 0px;
    }

    .el-table__body-wrapper .el-table__empty-block {
      width: 1140px !important;
    }
  }

  //.el-pagination {
  //  margin: 20px 0px 20px 500px;
  //}
}

/deep/.el-button--primary {
  background-color: #ff142f;
}

/deep/.el-button--primary:focus {
  background-color: #ff142f !important;
  border-color: #ff142f;
}

/deep/.el-button.el-button--primary-font-mini {
  background-color: #ff142f;
  border-color: #ff142f;
}

/deep/.el-button.el-button--default-mini:hover {
  color: #ff142f;
}

.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  border-color: #ff142f;
  margin-bottom: 20px;

  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}

.btn:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}

.btnBox {
  margin: 0px auto;
  width: 500px;
}

.bodys-right {
  float: left !important;
  padding: 0 6px;
}

/deep/ .el-dialog__body {
  width: 1180px !important;
}

/deep/ .el-table__row {
  .el-input {
    input {
      padding: 0 10px !important;
    }
  }
}

/deep/ .el-search {
  .ccui-search-wrapper {
    width: 51% !important;
  }
}

/deep/ .el-dialog__body-header {
  position: relative;
}

/deep/ .el-dialog__body-header .bodys-right-header {
  position: absolute;
  left: 646px;
  top: 0px;
}

/deep/th .cell {
  word-break: break-word !important;
}

/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}

.approval-btn {

  /deep/.el-button--text {
    color: #ff142f;
  }
}
</style>
